var map = {
	"./button_share": 75,
	"./button_share.png": 75,
	"./button_share.png:Zone.Identifier": 133,
	"./cancel-off": 76,
	"./cancel-off.png": 76,
	"./cancel-on": 77,
	"./cancel-on.png": 77,
	"./coffee": 78,
	"./coffee-bg": 79,
	"./coffee-bg.jpg": 79,
	"./coffee.png": 78,
	"./logo": 80,
	"./logo.png": 80,
	"./star-half": 81,
	"./star-half.png": 81,
	"./star-off": 82,
	"./star-off.png": 82,
	"./star-on": 83,
	"./star-on.png": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;